import { render, staticRenderFns } from "./CreateTicketForm.vue?vue&type=template&id=49ecd398&scoped=true"
import script from "./CreateTicketForm.vue?vue&type=script&lang=js"
export * from "./CreateTicketForm.vue?vue&type=script&lang=js"
import style0 from "./CreateTicketForm.vue?vue&type=style&index=0&id=49ecd398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ecd398",
  null
  
)

export default component.exports